const hasStoryblokLinkTarget = (link?: ConfigStoryblok['noConsentFallbackStory']) =>
    Boolean(link?.id || link?.cached_url || link?.url);

/** The configured landing page for users without the Academy consent, if the section has one. */
export const useNoConsentFallbackUrl = (config?: ConfigStoryblok | null) => {
    const fallbackStory = config?.noConsentFallbackStory;

    return hasStoryblokLinkTarget(fallbackStory) ? useStoryblokUrl(fallbackStory) : '';
};
